import React from 'react';
import { Link } from 'react-router-dom';
import { Cookie, X, Settings } from 'lucide-react';
import { useCookies } from '../context/CookieContext';
import { useLanguage } from '../context/LanguageContext';
import { Button } from './ui/button';

const CookieBanner = () => {
  const { showBanner, setShowBanner, acceptAll, acceptNecessary } = useCookies();
  const { t } = useLanguage();

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-slideUp">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-2xl border border-gray-200 p-6">
        <div className="flex items-start gap-4">
          <div className="p-3 bg-amber-100 rounded-xl">
            <Cookie className="w-6 h-6 text-amber-700" />
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-gray-800 mb-2">{t.cookies.title}</h3>
            <p className="text-gray-600 text-sm mb-4">
              {t.cookies.description}{' '}
              <Link to="/cookies" className="text-amber-700 hover:text-amber-800 underline">
                {t.cookies.link}
              </Link>
            </p>
            <div className="flex flex-wrap gap-3">
              <Button 
                onClick={acceptAll}
                className="bg-amber-700 hover:bg-amber-800 text-white"
              >
                {t.cookies.acceptAll}
              </Button>
              <Button 
                onClick={acceptNecessary}
                variant="outline"
                className="border-gray-300 hover:bg-gray-50"
              >
                {t.cookies.necessary}
              </Button>
              <Link to="/cookies">
                <Button 
                  variant="ghost"
                  className="text-gray-600 hover:text-gray-800"
                >
                  <Settings className="w-4 h-4 mr-2" />
                  {t.cookies.customize}
                </Button>
              </Link>
            </div>
          </div>
          <button 
            onClick={() => setShowBanner(false)}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <X className="w-5 h-5 text-gray-400" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;